import React from "react";
import PlataformaUnidadesPage from "../../leasecontrol/components/PlataformaUnidadesPage";
import { createWialonUnit, deleteWialonUnit, listWialonChipsDisponibles, listWialonHwTypes, listWialonIconLibrary, listWialonUnitGroups, listWialonUnits, syncWialonUnit, updateWialonUnit } from "../services/wialonUsers";

export default function WialonUnidadesPage() {
  return (
    <PlataformaUnidadesPage
      title="Vehiculos / Unidades"
      subtitle="Modulo de Wialon"
      listUnits={listWialonUnits}
      listHwTypes={listWialonHwTypes}
      listIconLibrary={listWialonIconLibrary}
      listChips={listWialonChipsDisponibles}
      listUnitGroups={listWialonUnitGroups}
      createUnit={createWialonUnit}
      updateUnit={updateWialonUnit}
      deleteUnit={deleteWialonUnit}
      syncUnit={syncWialonUnit}
      providerColor="#006d75"
    />
  );
}
